module.exports = __webpack_public_path__ + "static/media/ic-warning-red.326f19f1.svg";